/**
 * gets local storage value - returns null if key does not exist
 * @param {string} key local storage key
 * @param {string} storageType local or session storage
 */
function getStorageItem(storageType: "local" | "session", key) {
   if (storageType === "session") {
      if (!sessionStorage.getItem(key)) return null;
      return JSON.parse(sessionStorage.getItem(key));
   } else if (storageType === "local") {
      if (!localStorage.getItem(key)) return null;
      return JSON.parse(localStorage.getItem(key));
   }
}

/** sets local storage key and value
 * @param {string} key new local storage key
 * @param {string} value new local storage value
 * @param {string} storageType local or session storage
 */
function setStorageItem(storageType: "local" | "session", key, value) {
   if (storageType === "session") {
      sessionStorage.setItem(key, JSON.stringify(value));
   } else if (storageType === "local") {
      localStorage.setItem(key, JSON.stringify(value));
   }
   return value;
}

export { getStorageItem, setStorageItem };
